import { useMemo } from 'react';
import { Vector3 } from 'three';

import type { NEW__LabelingBox } from '@/util';

export const BoxArrowHelper = ({ box }: { box: NEW__LabelingBox }) => {
  const arrowDirection = useMemo(() => {
    const quaternion = box.boxMesh.quaternion;
    return new Vector3(1, 0, 0).applyQuaternion(quaternion);
  }, [box.quaternion]);
  const arrowPosition = useMemo(() => {
    const quaternion = box.boxMesh.quaternion;
    const offset = new Vector3(box.dimension[0] / 2, 0, 0).applyQuaternion(
      quaternion,
    );
    return new Vector3(...box.position).add(offset);
  }, [box.dimension, box.position, box.quaternion]);

  const offset = useMemo(() => {
    const quaternion = box.boxMesh.quaternion;
    return new Vector3(box.dimension[0] / 2, 0, 0).applyQuaternion(quaternion);
  }, [box.dimension, box.quaternion]);

  return (
    <arrowHelper
      args={[arrowDirection, offset, 1.5, 0xececec, 0.5, 0.375]}
      position={arrowPosition}
    />
  );
};
